import {Ventrata} from 'types'
import {ga4} from 'utils/ga4'

type Params = {
  product: Ventrata.Product
  option?: Ventrata.Option
}

export const addToCartButton = ({product, option}: Params) => {
  ga4({
    event: 'add_to_cart_button',
    item_id: product.id,
    item_name: product.title,
    item_variant: option?.title,
    checkout_type: 'custom_checkout',
  })
}
